module.exports = __webpack_public_path__ + "static/media/037.96337749.jpg";